// extracted by mini-css-extract-plugin
module.exports = {"tech_pills":"styles_tech_pills__OLqUW","tech_pill":"styles_tech_pill__sKOlt","dot":"styles_dot__uoNdF","hoverStyle":"styles_hoverStyle__LqsT6","icon":"styles_icon__a0P0r"};